import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-container',
  imports: [NgStyle],
  template: `
    <div class="card-container" [ngStyle]="{ padding: padding }">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .card-container {
        border-radius: 16px;
        background-color: var(--color-branco);
        box-shadow: 0px 0px 1px 0px #00082414;
      }
    `,
  ],
})
export class CardContainerComponent {
  @Input() padding = '24px 24px 40px 24px';
}
